export var TercType;
(function (TercType) {
    TercType[TercType["GMINA_MIEJSKA"] = 1] = "GMINA_MIEJSKA";
    TercType[TercType["GMINA_WIEJSKA"] = 2] = "GMINA_WIEJSKA";
    TercType[TercType["GMINA_MIEJSKO_WIEJSKA"] = 3] = "GMINA_MIEJSKO_WIEJSKA";
    TercType[TercType["MIASTO"] = 4] = "MIASTO";
    TercType[TercType["OBSZAR_WIEJSKI"] = 5] = "OBSZAR_WIEJSKI";
    TercType[TercType["DZIELNICA"] = 8] = "DZIELNICA";
    TercType[TercType["DELEGATURA"] = 9] = "DELEGATURA";
    TercType[TercType["WOJEWODZTWO"] = 100] = "WOJEWODZTWO";
    TercType[TercType["POWIAT"] = 110] = "POWIAT";
    TercType[TercType["GMINA"] = 120] = "GMINA";
})(TercType || (TercType = {}));
//# sourceMappingURL=tercType.enum.js.map